var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"daq-scroll-load",class:_vm.classname},[_vm._t("list"),_vm._v(" "),(_vm.noMore)?_c('p',{staticClass:"daq-no-data-text"},[_c('span',[_vm._v("没有更多了")])]):_vm._e(),_vm._v(" "),(_vm.noData)?_c('div',{staticClass:"daq-no-data"}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-38f883aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/scrollLoad/scrollLoad.vue
// module id = null
// module chunks = 